import { postContactMessage } from '@/api/contact'

const contact = {
  namespaced: true,
  state: () => ({
    status: {},
  }),
  getters: {},
  actions: {
    postMessage ({
      commit,
      dispatch
    }, data) {
      return new Promise((resolve, reject) => {
        postContactMessage(data)
          .then((response) => {
            resolve(response)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
  mutations: {},
}

export default contact
